/* tbody.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./tbody.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var bodyStyles = null;

/**
 * __TBody__
 * @primitive
 */
export var TBody = function TBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("tbody", {
    className: ax(["_19itglyw _kqswh2mm _9v7aidpf _18postnw _8x3ud1es _aetrb3bt _11fnglyw"]),
    style: {
      "--_1tz90uq": ix("inset 0 -2px 0 0 ".concat("var(--ds-border, #eee)"))
    }
  }, children);
};